export enum CookieType {
  AUTH = 'auth',
  VIEWING_USER = 'viewingUser',
  ADS_VIEW = 'adsView',
  INSIGHTS_VIEW = 'insightsView'
}

class LocalStorage {
  set(cookieType: string, object: any) {
    window.localStorage.setItem(cookieType, JSON.stringify(object))
  }

  get(cookieType: string) {
    const cookieValue = window.localStorage.getItem(cookieType)
    if (cookieValue !== null && cookieValue !== undefined) {
      try {
        return JSON.parse(cookieValue)
      } catch {
        console.error(`Unable to read ${cookieType}`)
        return null
      }
    }
    return null
  }

  remove(cookieType: string) {
    window.localStorage.removeItem(cookieType)
  }
}

export const cookies = new LocalStorage()
